/*Sidebar*/

import i_vias from './../UI/icons/Sidebar/Vias2.svg'
import i_vias2 from './../UI/icons/Sidebar/Vias.svg'
import i_beneficios from './../UI/icons/Sidebar/Puntos-interes2.svg'
import i_beneficios2 from './../UI/icons/Sidebar/Puntos-interes.svg'
import i_amenidades from './../UI/icons/Sidebar/Amenidades.svg'
import i_amenidades2 from './../UI/icons/Sidebar/Amenidades2.svg'
import i_etapas from './../UI/icons/Sidebar/Proyecto2.svg'
import i_etapas2 from './../UI/icons/Sidebar/Proyecto.svg'

import i_renders from './../UI/icons/Galerias/renders.svg'
import i_recor from './../UI/icons/Galerias/360.svg'
import i_back from './../UI/icons/back-btn.svg'

/*Amenities*/

import i_lobby from './../UI/icons/Amenities/Lobby.svg'
import i_hobbies from './../UI/icons/Amenities/Hobbies.svg'
import i_bicicletero from './../UI/icons/Amenities/bicicletero.svg'
import i_gym from './../UI/icons/Amenities/Gym.svg'
import i_saladejuegos from './../UI/icons/Amenities/salonjuegos.svg'
import i_saloncomunal from './../UI/icons/Amenities/saloncomunal.svg'
import i_bbq from './../UI/icons/Amenities/BBQ.svg'
import i_commercialarea from './../UI/icons/Amenities/CommercialArea.svg'
import i_zonashumedas from './../UI/icons/Amenities/jacuzzi.svg'
import i_bienestar from './../UI/icons/Amenities/bienestar.svg'
import i_yoga from './../UI/icons/Amenities/yoga.svg'
import i_entretenimiento from './../UI/icons/Amenities/8pool.svg'
import i_videogames from './../UI/icons/Amenities/videogames.svg'
import i_lecturak from './../UI/icons/Amenities/kidBook.svg'
import i_books from './../UI/icons/Amenities/book.svg'
import i_party from './../UI/icons/Amenities/party.svg'
import i_pet from './../UI/icons/Amenities/pet.svg'
import i_laundry from './../UI/icons/Amenities/laundry.svg'
import i_parque from './../UI/icons/Amenities/parqueinfantil.svg'
import i_cowork2 from './../UI/icons/Amenities/Coworking White.svg'
import i_cowork from './../UI/icons/Amenities/Coworking.svg'

import i_lobby2 from './../UI/icons/Amenities/Lobby2.svg'
import i_hobbies2 from './../UI/icons/Amenities/Hobbies2.svg'
import i_bicicletero2 from './../UI/icons/Amenities/bicicletero2.svg'
import i_gym2 from './../UI/icons/Amenities/Gym2.svg'
import i_saladejuegos2 from './../UI/icons/Amenities/salonjuegos2.svg'
import i_saloncomunal2 from './../UI/icons/Amenities/saloncomunal2.svg'
import i_bbq2 from './../UI/icons/Amenities/BBQ2.svg'
import i_commercialarea2 from './../UI/icons/Amenities/CommercialArea2.svg'
import i_zonashumedas2 from './../UI/icons/Amenities/jacuzzi2.svg'
import i_bienestar2 from './../UI/icons/Amenities/bienestar2.svg'
import i_yoga2 from './../UI/icons/Amenities/yoga2.svg'
import i_entretenimiento2 from './../UI/icons/Amenities/8pool2.svg'
import i_videogames2 from './../UI/icons/Amenities/videogames2.svg'
import i_lecturak2 from './../UI/icons/Amenities/kidBook2.svg'
import i_books2 from './../UI/icons/Amenities/book2.svg'
import i_party2 from './../UI/icons/Amenities/party2.svg'
import i_pet2 from './../UI/icons/Amenities/pet2.svg'
import i_laundry2 from './../UI/icons/Amenities/laundry2.svg'
import i_parque2 from './../UI/icons/Amenities/parqueinfantil2.svg'

/*POIS*/
import i_salud from './../UI/icons/POI/Salud.svg'
import i_comercio from './../UI/icons/POI/Comercio.svg'
import i_transporte from './../UI/icons/POI/Transporte.svg'
import i_otros from './../UI/icons/POI/Otros.svg'
import i_colegios from './../UI/icons/POI/Educacion.svg'
import i_parques from './../UI/icons/POI/Parques.svg'
import i_cultural from './../UI/icons/POI/Cultural.svg'

import i_salud2 from './../UI/icons/POI/Salud2.svg'
import i_comercio2 from './../UI/icons/POI/Comercio2.svg'
import i_transporte2 from './../UI/icons/POI/Transporte2.svg'
import i_otros2 from './../UI/icons/POI/Otros2.svg'
import i_colegios2 from './../UI/icons/POI/Educacion2.svg'
import i_parques2 from './../UI/icons/POI/Parques2.svg'
import i_cultural2 from './../UI/icons/POI/Cultural2.svg'

export default {
    /*Sidebar*/
    'vias': i_vias,
    'vias2': i_vias2,
    'beneficios': i_beneficios,
    'beneficios2': i_beneficios2,
    'amenidades': i_amenidades,
    'amenidades2': i_amenidades2,
    'etapas': i_etapas,
    'etapas2': i_etapas2,
    'renders': i_renders,
    'recorridos': i_recor,
    'back': i_back,

    /*Amenidades*/
    'Lobby de Acceso': i_lobby,
    'Lobby de Acceso2': i_lobby2,
    'Salón Infantil': i_hobbies,
    'Salón Infantil2': i_hobbies2,
    'Bicicleteros': i_bicicletero,
    'Bicicleteros2': i_bicicletero2,
    'Gimnasio': i_gym,
    'Gimnasio2': i_gym2,
    'Salón Juvenil': i_saladejuegos,
    'Salón Juvenil2': i_saladejuegos2,
    'Salón Social': i_saloncomunal,
    'Salón Social2': i_saloncomunal2,
    'BBQ': i_bbq,
    'BBQ2': i_bbq2,
    'Zona Comercial': i_commercialarea,
    'Zona Comercial2': i_commercialarea2,
    'Zonas Húmedas': i_zonashumedas,
    'Zonas Húmedas2': i_zonashumedas2,
    'Salón de Bienestar': i_bienestar,
    'Salón de Bienestar2': i_bienestar2,
    'Salón de Yoga': i_yoga,
    'Salón de Yoga2': i_yoga2,
    'Sala de Entretenimiento': i_entretenimiento,
    'Sala de Entretenimiento2': i_entretenimiento2,
    'Sala de Videojuegos': i_videogames,
    'Sala de Videojuegos2': i_videogames2,
    'Sala de Lectura de Niños': i_lecturak,
    'Sala de Lectura de Niños2': i_lecturak2,
    'Sala de Lectura de Adultos': i_books,
    'Sala de Lectura de Adultos2': i_books2,
    'Salón de Piñatas': i_party,
    'Salón de Piñatas2': i_party2,
    'Pet Park': i_pet,
    'Pet Park2': i_pet2,
    'Lavandería': i_laundry,
    'Lavandería2': i_laundry2,
    'Juegos Infantiles': i_parque,
    'Juegos Infantiles2': i_parque2,
    'Coworking': i_cowork,
    'Coworking2': i_cowork2,

    /**/
    "Salud": i_salud,
    "Salud2": i_salud2,
    "Comercio": i_comercio,
    "Comercio2": i_comercio2,
    "Estaciones de Metro": i_transporte,
    "Estaciones de Metro2": i_transporte2,
    "Otros": i_otros,
    "Otros2": i_otros2,
    "Colegios": i_colegios,
    "Colegios2": i_colegios2,
    "Parques": i_parques,
    "Parques2": i_parques2,
    "Culturales": i_cultural,
    "Culturales2": i_cultural2,
}